export default {
	termsAndConditions: {
		lastUpdate: '마지막 업데이트: 2024년 6월 10일',
		content: `
		<p>아래의 약관은 중요합니다:</p>
		<ul>
			<li>{siteName}에서의 법적 권리를 설정합니다.</li>
			<li>{siteName}을 사용할 때 우리에게 부여하는 권리를 설명합니다.</li>
			<li>{siteName}을 사용할 때 모든 사용자가 준수해야 하는 규칙을 설명합니다.</li>
		</ul>
		<p>이 약관을 주의 깊게 읽어보시고, 당사의 {privacyPolicyLink} 및 이 약관에서 언급된 기타 문서도 읽어보시기 바랍니다.</p>
		<p>시작해 봅시다...</p>
		<h3>1. {siteNameUpper} 소개 및 데이터</h3>
		<p>웹사이트 {websiteLink} (이하 "웹사이트")는 회사 {siteName} S.L (이하 "{siteName}")의 소유입니다. {siteName}은 스페인 법률에 따라 설립된 회사로, 주소는 Avenida de Cerdanyola, nº 75, 1º, Sant Cugat del Vallès (Barcelona)이며, CIF 번호 B-56.768.260을 보유하고 있으며, 바르셀로나 상업 등록부에 볼륨 49065, 페이지 0033, 시트 B-606324, 첫 번째 등록으로 등록되어 있습니다.</p>
		<p>{siteName}은 웹사이트를 통해 더 잘 알 수 있도록 하고, 제공하는 서비스를 알 수 있도록 하며, 원하시면 연락을 취하거나 계약할 수 있도록 웹사이트를 제공합니다.</p>
		<h3>2. 이용 약관의 목적 및 적용 범위</h3>
		<p>이 이용 약관은 {privacyPolicyLink} 및 {cookiesPolicyLink}와 함께 웹사이트 {websiteLink}의 이용을 규제하는 법적 프레임워크를 구성합니다. 이 이용 약관은 언제든지 웹사이트에서 영어로 열람, 저장 또는 인쇄할 수 있도록 제공됩니다.</p>
		<p>{siteName}이 수행하는 개인 데이터 처리에 관한 모든 질문을 알기 위해서는 당사의 {privacyPolicyLink} 및 {cookiesPolicyLink}를 방문하시기 바랍니다. 이 두 정책도 언제든지 영어로 열람, 저장 또는 인쇄할 수 있도록 제공됩니다.<br />{siteName}은 웹사이트에서 타사 쿠키를 사용합니다. {websiteLink}에서 사용하는 쿠키 유형, 목적 및 이러한 쿠키를 사용하지 않으려는 경우 브라우저를 설정하는 방법에 대해 자세히 알아보려면 당사의 {cookiesPolicyLink}를 방문하십시오.</p>
		<p>이 이용 약관과 {privacyPolicyLink}, {cookiesPolicyLink}는 현재 적용되는 규정, 특히 정보 사회 서비스 및 전자 상거래에 관한 2002년 7월 11일의 법률 34/2002 및 2016년 4월 27일 유럽 의회 및 이사회 규정 (EU) 2016/679의 규정에 따라 작성되었습니다. 이 규정은 자연인의 개인 데이터 처리 및 해당 데이터의 자유로운 이동과 관련된 보호에 관한 것이며, 지침 95/46/CE를 폐지합니다.</p>
		<h3>3. 웹사이트 접근 및 수락</h3>
		<p>웹사이트 접근은 인터넷 서비스 제공업체와 계약한 통신 네트워크를 통한 연결 비용과 관련된 부분을 제외하고 무료입니다. 웹사이트를 자유롭게 탐색하고 원하는 만큼 접속할 수 있습니다. 웹사이트에 접근하고 탐색하기 위해 등록할 필요는 없지만, 서비스를 이용하려면 등록이 필요합니다.</p>
		<p>웹사이트 사용은 웹사이트 사용자 ("사용자")의 상태를 부여하며, 이러한 이용 약관 및 웹사이트의 {privacyPolicyLink}, {cookiesPolicyLink}를 완전하고 무조건적으로 수락하는 것을 의미합니다. 또한, 서비스 사용을 불법적인 목적으로 사용하지 않을 것에 동의합니다.</p>
		<p>웹사이트에 접근하고 탐색함으로써, 사용자는 법적 책임 하에 성인임을 선언하고, 웹사이트에 접근하고 이를 사용할 법적 능력이 있으며, 이러한 이용 약관을 완전히 이해하고 수락함을 선언합니다.</p>
		<p>또한, 법적 이유로 인해 구매가 이루어진 전자 문서를 보관합니다. 이 문서에 언제든지 {supportLink}를 통해 요청하여 접근할 수 있습니다.</p>
		<h3>4. 웹사이트 이용 조건</h3>
		<p>사용자는 이 이용 약관, 현재 법률 및 선의에 따라 웹사이트를 사용할 것에 동의합니다. 따라서 사용자는 이 이용 약관, 법률 및 선의에 반하는 웹사이트 사용으로 인해 {siteName} 및 제3자에게 발생한 손해 및 손실에 대해 책임을 집니다.</p>
		<h3>5. 서비스 설명</h3>
		<p>{siteName}은 이미지를 편집하기 위한 서비스 구독을 허용합니다.</p>
		<p>{siteName}과 구매자 간의 계약이 체결되는 언어는 원산지 국가의 언어입니다.<br />온라인 서비스에서 구매 절차는 다음과 같습니다:</p>
		<ol>
			<li>사용자 이름과 비밀번호로 웹사이트에 등록해야 합니다.</li>
			<li>등록 시, 사용자는 가격 섹션에 있는 결제 계획 중 하나를 선택해야 하며, 선택한 계획에 따라 크레딧이 부여됩니다. 각 크레딧은 하나의 이미지를 편집할 수 있습니다.</li>
			<li>서비스를 구매한 후, 사용자는 관리 패널을 통해 다음을 찾을 수 있습니다:
				<ul>
					<li>처리된 모든 이미지의 목록이 있는 섹션으로, 원하는 만큼 이미지를 편집하고 기기에 다운로드할 수 있습니다.</li>
					<li>청구서 및 구독 취소를 확인하기 위한 계획 및 결제 섹션.</li>
					<li>계정 설정을 변경할 수 있는 내 계정 섹션.</li>
				</ul>
			</li>
		</ol>
		<p>서비스 구매 후, 최대 24시간 이내에 지정된 주소로 이메일을 통해 확인됩니다. 서비스, 구독 취소 방법, 금액, 적용 세금, 결제 방법 및 적용 약관이 명시됩니다.</p>
		<h4>5.1 구독</h4>
		<p>서비스 구독은 선택한 계획에 따라 다르며, 종료될 때까지 동일한 기간 동안 자동으로 갱신됩니다. 구독을 취소하지 않는 한, 결제 수단에 해당 연간 구독료를 청구할 수 있도록 권한을 부여합니다.</p>
		<p>서비스 구독은 언제든지 취소할 수 있으며, 연간 청구 기간이 종료될 때까지 계속 액세스할 수 있습니다. 법이 허용하는 한도 내에서, 결제는 환불되지 않으며, 부분적인 연간 구독 기간에 대한 환불 또는 크레딧은 제공되지 않습니다.</p>
		<h3>6. 가격 및 세금</h3>
		<p>{siteName}에서 제공하는 제품의 가격은 유로 (€) 또는 구매가 이루어진 국가의 통화로 표시되며, 제품 가격에 적용되는 부가가치세 (VAT)가 적용됩니다.</p>
		<p>어떤 경우에는 사용자의 거주 국가나 사용자의 조건에 따라 VAT가 면제되거나 적용되지 않을 수 있습니다. 이로 인해 일부 경우에는 주문의 최종 가격이 표시된 가격과 다를 수 있습니다.<br />VAT를 면제받는 주체가 구매한 경우, 해당 주체는 VAT/NIF 번호를 {supportLink}으로 이메일을 통해 보내면, 해당 세금이 기록되지 않습니다.</p>
		<h3>7. 결제 방법</h3>
		<p>구매한 서비스의 온라인 결제는 신용카드 또는 직불카드로 이루어질 수 있습니다. 이와 관련하여, {siteName}은 신용카드 및 직불카드 소유자에게 온라인 스토어의 거래가 안전한 결제 게이트웨이를 통해 SSL 기술을 사용하여 데이터 전송의 보안을 보장한다고 알립니다.</p>
		<h3>8. 철회권 및 환불</h3>
		<h4>8.1. 철회권</h4>
		<p>QR 디지털 형식의 소프트웨어로 판매되는 제품의 특성상, 2007년 11월 16일의 법령 1/2007, 일반 소비자 및 사용자 보호법 및 기타 관련 법률의 개정된 본문에 따라 철회권이 적용되지 않습니다.</p>
		<h4>8.2. 환불</h4>
		<p>사용자가 선택한 계획과 관계없이, 법이 허용하는 한도 내에서 사용자가 지불한 금액은 환불되지 않습니다.</p>
		<p>계약된 서비스는 다른 서비스 사용자에게 양도할 수 없습니다.</p>
		<p>어떤 경우에도 사용자는 계약된 기간이 끝날 때까지 계약된 서비스를 사용할 수 있습니다.</p>
		<h3>9. 제안의 유효성</h3>
		<p>서비스에서 제공되는 서비스 및 그 가격은 이 웹사이트를 통해 표시되는 서비스 카탈로그에 있는 동안 구매할 수 있습니다.</p>
		<p>{siteName}은 시장에 따라 제품 및 서비스를 업데이트할 수 있도록 서비스에 적절한 변경을 할 수 있는 권리를 보유합니다.</p>
		<p>{siteName}은 사전 통지 없이 가격을 변경할 권리를 보유합니다. 서비스의 가격에 대한 업데이트에도 불구하고 오류가 있을 수 있습니다. 우리는 발견된 오류를 신속하게 수정할 것이지만, 이는 서비스에 대해 구속력을 가지지 않습니다.</p>
		<h3>10. 안전성</h3>
		<p>앞서 언급했듯이, 구매 절차 전체와 개인 데이터 및 결제 시스템의 전송은 SSL 프로토콜을 통해 암호화된 안전한 페이지에서 이루어집니다.</p>
		<p>우리는 현재 기술 지식을 바탕으로 서비스의 안전성을 보장합니다. 그러나, {siteName}은 서비스의 미래 안전성을 보장할 수 없습니다. 어떤 경우에도, 우리는 가능한 한 빨리 보안 위반을 수정하고 적절한 수정 조치를 취할 것을 약속합니다.</p>
		<p>사용자는 신원 도용 상황이 발생할 수 있는 상황을 즉시 이메일 {supportLink}을 통해 {siteName}에 통보하는 것에 동의합니다.</p>
		<h3>11. 수정 및 무효</h3>
		<p>미래에 서비스의 약관 및 조건을 업데이트할 수 있으며, 서비스 자체의 기능과 기능도 업데이트할 수 있습니다.</p>
		<p>우리는 웹사이트의 눈에 띄는 곳에 공지를 올리거나 이메일을 통해 약관 및 조건의 변경 사항을 알릴 것입니다.</p>
		<p>이 약관에 포함된 조항이 전체 또는 일부가 무효 또는 무효로 선언된 경우, 해당 조항 또는 무효인 부분에만 영향을 미칩니다. 나머지 약관은 여전히 유효하며, 해당 조항 또는 영향을 받는 부분은 배제된 것으로 간주됩니다.</p>
		<h3>12. 계약으로 인한 청구 및 조치</h3>
		<p>가능한 한, 이 서비스는 스페인 법률의 적용을 받습니다.<br />민사 절차를 통해 청구를 해결하고 비용을 줄이기 위해, 우리는 상업 및 산업 협회의 중재 법원의 형평성 중재에 따를 가능성을 배제하지 않습니다. 이와 관련하여, 적용 법규에 따라, {siteName}은 유럽 온라인 분쟁 해결 플랫폼의 존재를 알립니다. 이 플랫폼은 인터넷 서비스 제공자와의 계약도 온라인으로 체결된 계약에 대한 이러한 분쟁의 비사법적 해결을 촉진합니다. 이 플랫폼은 다음 웹사이트를 통해 접근할 수 있습니다: <a href="http://ec.europa.eu/odr" target="_blank">http://ec.europa.eu/odr</a></p>
		<h3>13. 지적 재산권 및 산업 재산권</h3>
		<p>웹사이트 및 그 콘텐츠는 현재의 국가 지적 재산권 및/또는 산업 재산권 규정에 따라 보호되며, 이러한 문제에 적용 가능한 국제 협약에도 적용됩니다. {siteName}은 웹사이트 및 그 콘텐츠에 대한 모든 지적 재산권 및 산업 재산권의 소유자이거나 적절하게 라이센스가 부여된 자입니다.</p>
		<p>상업적 목적이든 아니든, 사전 명시적 동의 없이 웹사이트 또는 그 콘텐츠의 재생산, 배포, 공중 송신, 변형, 제공 및 일반적으로 다른 모든 형태의 사용은 엄격히 금지됩니다. {siteName}의 지적 재산권 및 산업 재산권 소유자로서의 식별 데이터를 삭제하는 것은 명시적으로 금지됩니다.</p>
		<p>{siteName}은 웹사이트 및 그 콘텐츠에 대한 모든 지적 재산권 및 산업 재산권을 보유하며, 불법적인 웹사이트 또는 그 콘텐츠의 사용을 중단, 방지 또는 기소하기 위해 적절한 법적 조치를 취할 권리를 보유합니다. 어떤 경우에도, 웹사이트에 대한 접근 또는 사용은 {siteName}이 웹사이트 또는 그 콘텐츠에 대한 지적 재산권 또는 산업 재산권을 양도한다는 것을 의미하지 않습니다. {siteName}이 불법적인 웹사이트 또는 콘텐츠의 사용을 중단할 것을 요구하지 않는 경우, 이는 해당 사용에 대한 암묵적인 동의나 법적 조치의 포기를 의미하지 않습니다.</p>
		<h3>14. 책임 및 보증</h3>
		<p>사용자는 이 이용 약관, 현재 법률 및 선의에 따라 웹사이트 및 그 콘텐츠를 사용해야 합니다. 이 일반 조건, 법률 또는 선의에 반하는 웹사이트 또는 그 콘텐츠의 모든 사용은 금지됩니다, 경제적 목적이 있는지 여부에 관계없이.<br />사용자는 이 이용 약관, 법률, 도덕, 공공 질서 또는 선의에 반하는 웹사이트 또는 그 콘텐츠의 사용으로 인해 {siteName} 또는 제3자에게 직접적 또는 간접적으로 발생한 손해에 대해 책임을 집니다.</p>
		<p>웹사이트 및 그 콘텐츠를 사용자에게 제공하기 위해 {siteName}은 제3자가 제공하는 서비스를 필요로 합니다. {siteName}이 웹사이트를 사용 가능하고 접근할 수 있도록 유지하려는 노력에도 불구하고, 외부 요인으로 인해 그 가용성이 일시 중단, 중단 또는 취소될 수 있습니다. 이로 인해 {siteName}은 웹사이트 또는 그 콘텐츠에 대한 접근의 중단 또는 오류, 업데이트 상태 또는 최신 버전의 항상 표시 여부를 보장하지 않습니다. 결과적으로, {siteName}은 웹사이트의 중단, 중단, 연속성 부족, 네트워크 장애 또는 연결 끊김으로 인해 사용자 또는 제3자에게 발생할 수 있는 손해에 대해 책임을 지지 않습니다.</p>
		<p>어떤 경우에도, {siteName}은 사용자에게 귀책되지 않는 원인으로 인한 손해에 대해 책임을 지지 않습니다, 예를 들어, 천재지변, 불가항력, 바이러스, 유해 요소, 브라우저 오작동, 네트워크 중단, 컴퓨터 침입 또는 제3자 공격.</p>
		<h3>15. 링크</h3>
		<p>웹사이트, 플랫폼, 포럼, 채팅, 블로그 또는 외부 소셜 네트워크가 웹사이트에 링크하거나 링크하는 경우, 이는 {siteName}의 승인 또는 감독을 받지 않으며, 해당 링크 또는 링크가 {siteName}과 웹사이트, 플랫폼, 포럼, 채팅, 블로그 또는 외부 소셜 네트워크 간의 연관성을 의미하지 않는다고 명확히 알립니다.</p>
		<p>어떤 경우에도, 웹사이트로의 링크는 웹사이트의 홈 페이지나 시작 페이지로 직접 연결되어야 하며, 클릭 시 전체 화면을 덮는 URL을 사용하여 링크가 절대적이고 완전하게 이루어져야 합니다. {siteName}은 제3자 웹사이트, 플랫폼, 포럼, 채팅, 블로그 또는 소셜 네트워크에 대한 내용, 정보 또는 데이터에 대해 어떤 경우에도 책임을 지지 않습니다.</p>
		<p>법, 도덕 및 관습에 반하는 웹사이트, 플랫폼, 포럼, 채팅, 블로그 또는 소셜 네트워크에서 웹사이트로의 링크는 명시적으로 금지됩니다, 특히 포르노, 불법, 불법 또는 인권 침해 콘텐츠를 포함한 경우.</p>
		<p>한편, 웹사이트는 제3자 웹사이트, 플랫폼, 포럼, 채팅, 블로그 또는 소셜 네트워크로의 링크를 포함할 수 있습니다. {siteName}은 제3자 웹사이트의 정보와 콘텐츠를 알거나 통제할 수 있는 인적 및/또는 기술적 수단을 가지고 있지 않습니다. 따라서 {siteName}은 연결된 사이트의 콘텐츠에 대해 어떤 경우에도 책임을 지지 않으며, 해당 링크가 {siteName}이 해당 사이트의 콘텐츠를 알고 있다는 것을 의미하지 않습니다.</p>
		<h3>16. 데이터 보호</h3>
		<p>{siteName}은 {privacyPolicyLink}에 명시된 바와 같이 사용자의 데이터를 사용, 기밀성을 존중하고, 데이터 처리 목적에 따라 사용하며, 개인 데이터 보호 관련 법률에 따라 이를 보호하기 위해 모든 조치를 취할 것을 약속합니다.</p>
		<p>웹사이트는 적절한 보안 조치를 통합하고 산업 표준 기술을 사용하여 수집된 개인 데이터의 보안, 무결성, 완전성, 정확성을 개선하며, 데이터 손실이나 오용을 방지하기 위해 합리적인 예방 조치를 취했습니다. 데이터 보호 및 보안 규칙은 정기적으로 검토 및 개선되며, 승인된 사람만 사용자가 제공한 정보에 접근할 수 있도록 노력합니다.</p>
		<p>{siteName}이 데이터 처리 및 관리를 어떻게 수행하는지 더 알고 싶다면, 당사의 {privacyPolicyLink} 및 {cookiesPolicyLink}를 읽어보십시오.</p>
		<h3>17. 기간 및 수정</h3>
		<p>이 이용 약관은 사용자가 열람할 수 있는 동안 유효하며, 전부 또는 일부가 수정되거나 업데이트되면 이 약관은 효력을 상실하고, 새로운 이용 약관이 웹사이트 사용을 규제합니다.</p>
		<p>{siteName}은 언제든지 이 이용 약관을 검토, 수정 또는 업데이트할 권리를 보유합니다. 어떤 이유로든 이 이용 약관에 변경 사항이 있을 경우, {siteName}은 사용자에게 웹사이트의 홈 페이지에 해당 사항을 공지하여 이를 알리고, 이 이용 약관의 수정, 변경 또는 업데이트를 만족스럽게 확인할 수 있도록 합니다.</p>
		<h3>18. 일반</h3>
		<p>어떤 경우에도, {siteName}이 권리를 행사하지 않는 것은 이를 포기하는 것으로 간주되지 않습니다.</p>
		<p>이 이용 약관에 포함된 제목은 단순히 참고용이므로, 해석에 영향을 미치지 않습니다.</p>
		<p>이 이용 약관의 조항이 전체 또는 일부가 무효, 남용 또는 집행 불가능한 것으로 선언된 경우, 해당 선언은 해당 조항 또는 그 일부에만 영향을 미치며, 다른 조건에는 영향을 미치지 않습니다.</p>
		<p>이 이용 약관과 {privacyPolicyLink}, {cookiesPolicyLink}는 현재 스페인 법률의 적용을 받습니다.</p>
		<h3>19. 고객 서비스</h3>
		<p>명확한 설명, 사건 또는 불만 사항이 있는 경우 다음을 통해 문의할 수 있습니다:<br />이메일: {supportLink}<br />우편 주소: Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spain.</p>`
	},
	privacyPolicy: {
		lastUpdate: '마지막 업데이트: 2024년 6월 10일',
		content: `
			<h3>1. 책임자 및 설명</h3>
			<h5>1.1. 책임자</h5>
			<p>이 사이트의 처리 책임자는 Remove Background S.L (이하 Remove Background 또는 서비스)로, 주소는 Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spain입니다.</p>
			<p>NIF: B56768260<br> 이메일: {supportLink}</p>

			<h5>1.2. 설명</h5>
			<p>Remove Background의 개인정보 보호정책(이하 "개인정보 보호정책")의 수락은 당사 웹사이트 및 서비스(이하 "서비스")를 이용하는 데 필요한 조건입니다.<br>
				이 개인정보 보호정책은 사용자로서의 Remove Background의 개인정보 및 비개인정보의 수집, 처리 및 사용을 규제합니다.<br>
				Remove Background는 사용자의 개인정보를 처리하기 위해 현지 및 유럽 법률을 준수합니다.</p>


			<h3>2. 수집된 정보</h3>
			<p>당사 웹사이트에 액세스하는 데 필요한 정보는 제공할 필요가 없지만, 등록 및/또는 요금제를 계약하려면 일부 개인정보를 제공해야 합니다. 서비스에서 수집한 정보(개인 또는 비개인 정보)는 다음 세 가지 방법으로 당사에 전달됩니다: 1) 자동으로 수집된 정보 2) 자발적으로 제공한 정보 3) 제3자가 제공한 정보.</p>

			<h5>2.1. 자동으로 수집된 정보</h5>
			<p>이 정보는 다음과 같습니다:</p>
			<ul>
				<li>쿠키 또는 유사한 메커니즘을 통해 사용자의 기기에 저장된 정보로, 항상 사용자의 동의 또는 기타 법적 근거에 따라 수집됩니다. 자세한 내용은 쿠키 정책을 참조하십시오.</li>
				<li>연결된 IP 주소, 사용된 장치 유형 및 특성, 운영 체제 버전, 브라우저 유형, 언어, 날짜, 국가, 요청 시간, 참조 URL, 이동할 URL 또는 사용된 모바일 네트워크 등의 정보입니다.</li>
				<li>서비스 사용 데이터 및 사용 중 감지된 가능한 오류.</li>
				<li>또한, Remove Background는 Google Analytics를 사용하며, 이는 미국 캘리포니아주 마운틴뷰에 본사를 둔 Google, LLC에서 제공하는 분석 서비스입니다. 이러한 서비스를 제공하기 위해 쿠키를 사용하여 사용자의 IP 주소를 포함한 정보를 수집하며, 이는 www.google.com에 명시된 조건에 따라 Google에 의해 전송, 처리 및 저장됩니다. 법적 요구 사항이나 Google을 대신하여 정보를 처리하는 경우 제3자에게 해당 정보가 전송될 수 있습니다.</li>
			</ul>
			<p>어떤 경우든지, 여기에서 Google Analytics 쿠키를 비활성화할 수 있습니다: <a href="{externalLink: disableGoogleAnalyticsLink}">here</a>.</p>

			<h5>2.2. 자발적으로 제공된 정보</h5>
			<p>이 정보는 다음과 같습니다:</p>
			<ul>
				<li>모든 데이터는 필수입니다.</li>
				<li>Remove Background에서 웹사이트에 등록하기 위해 요구하는 정보: 이름과 성, 주소 및 이메일 등.</li>
				<li>모든 데이터는 필수입니다.</li>
				<li>서비스 계약을 완료하기 위해 필요한 정보(예: 이메일 주소 및 신용카드 또는 직불카드 번호).</li>
				<li>연락처 또는 의견 채널을 통해 발송된 메시지에 포함된 정보(개인 또는 비개인 정보)로, 예를 들어 이름과 이메일 등이 포함됩니다.</li>
			</ul>

			<h5>2.3. 제3자가 제공한 정보</h5>
			<p>이 정보는 다음과 같습니다:</p>
			<ul>
				<li>결제 시스템 또는 신용카드 처리기가 제공한 정보로, 구매 시기 또는 금액 등이 포함됩니다.</li>
			</ul>


			<h3>3. 권리 및 목적</h3>
			<p>양식 작성은 자발적임을 알려드립니다. 그러나 필수 항목(보통 별표로 표시됨)을 작성하지 않으면 서비스의 일부 기능을 사용할 수 없거나 제한될 수 있습니다.<br>
				제공한 개인정보는 Remove Background의 처리 활동 기록에 포함되어 요청을 처리하고, 요청된 서비스를 제공하며, 회사 및 서비스 관련 사항에 대해 정보를 제공하기 위해 처리됩니다.<br>
				개인정보에 대한 접근, 수정, 삭제, 처리 제한, 반대 및 데이터 이동 권리를 언제든지 이메일 {supportLink} 또는 우편 주소: Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spain로 행사할 수 있습니다.<br>
				이 경우, 이름과 성명, 필요한 경우 DNI 또는 국가 신분증 사본을 제공하여 본인임을 확인해야 합니다.<br>
				특정 목적으로 동의를 제공한 경우, 언제든지 동의를 철회할 권리가 있으며, 철회 이전에 동의를 기반으로 한 처리의 적법성에는 영향을 미치지 않습니다.<br>
				또한, Remove Background가 사용자의 데이터를 처리하는 방식에 문제가 있다고 생각되면, <a href="{knowYourRightsLink}">해당 데이터 보호 기관</a>에 불만을 제기할 수 있으며, 스페인의 경우 <a href="{aepdLink}">스페인 데이터 보호 기관</a>에 불만을 제기할 수 있습니다.</p>


			<h3>4. 나이</h3>
			<p>온라인 서비스 사용과 관련하여, 사용자는 성인임을 선언하고, 본 계약에 구속되며, 해당 약관에 따라 사이트를 사용할 법적 능력이 있음을 선언합니다.<br>
				서비스에 접근하기 위해 제공된 모든 정보는 진실되고, 완전하며, 정확하다고 선언합니다.</p>


			<h3>5. 데이터 사용</h3>
			<p>Remove Background는 수집된 데이터를 다음 목적으로 사용합니다:</p>
			<ul>
				<li>서비스 관리 및 업데이트 (법적 근거는 서비스 유지 및 업데이트에 대한 정당한 이익입니다).</li>
				<li>사용자의 질문에 응답 (법적 근거는 사용자 요청 및 질문에 대한 정당한 이익입니다).</li>
				<li>결제 처리 (법적 근거는 계약입니다).</li>
				<li>계약된 서비스 제공 (법적 근거는 계약입니다).</li>
				<li>서비스의 보안 유지, 불법 활동 조사, 약관 시행 및 국가 보안 기관의 조사 지원 (법적 근거는 서비스 및 사용자 보안 유지에 대한 정당한 이익입니다).</li>
			</ul>
			<p>Remove Background는 자동화된 결정을 사용하지 않으며, 기본 사용자 프로필을 생성할 수 있으며, 법적 근거는 상업적 목적 및 개인화된 제안을 제공하기 위한 정당한 이익입니다.<br>
				또한, Remove Background는 사용자의 정보를 집계되고 익명화된 데이터 형식으로 제3자에게 표시할 수 있습니다. 사용 통계 및 인구 통계 정보를 제3자와 공유할 수 있습니다. 그러나 이러한 정보는 제3자가 사용자를 개인적으로 식별할 수 없도록 합니다.</p>

			<h5>5.1. 이메일 및 연락처 양식</h5>
			<p>웹사이트는 사용자가 표준 연락처 양식을 통해 안전하게 개인 데이터를 보낼 수 있도록 하는 SSL 암호화를 사용합니다.<br>
				수집된 개인 데이터는 자동화된 처리가 이루어지며, Remove Background가 소유한 처리 활동 기록 파일에 포함됩니다.</p>
			<p>이와 관련하여:</p>
			<ul>
				<li>사용자의 IP 주소를 수신하며, 이는 메시지의 출처를 확인하고 적절한 권장 사항을 제공하기 위해 사용됩니다 (예: 정보를 올바른 언어로 표시). 또한, 잠재적인 비정상적인 활동을 감지하는 데 사용됩니다 (예: 사이버 공격 시도).</li>
				<li>또한, 사용자는 전화, 이메일 및 기타 통신 수단을 통해 데이터를 제공할 수 있습니다.</li>
			</ul>
			<p>사용된 결제 수단과 관련하여:</p>
			<ul>
				<li>당사의 결제 서비스 제공업체는 신용카드 또는 직불카드입니다. 사용자가 결제 시 제공한 은행 정보(예: 신용카드 번호)에 대한 접근 권한은 서비스 또는 직원에게 없습니다.</li>
			</ul>


			<h3>6. 데이터 보관</h3>
			<p>다음은 서비스에서 처리된 데이터의 보관 기간입니다:</p>
			<ul>
				<li>집계된 데이터는 삭제 기간 없이 보관됩니다.</li>
				<li>
					고객 데이터는 최소한으로 보관되며, 다음 기간까지 보관될 수 있습니다:
					<ul>
						<li>5년, 민법 제1964조에 따라 (특별 기한 없는 개인 행동).</li>
						<li>6년, 상법 제30조에 따라 (회계 장부 또는 송장 등).</li>
					</ul>
				</li>
				<li>사용자 데이터는 요청을 처리하기 위해 최대 12개월 동안 보관됩니다.</li>
			</ul>


			<h3>7. 제3자와 공유된 데이터</h3>
			<p>서비스의 일부를 관리하는 제3자가 있습니다.<br>
				Remove Background는 적용 가능한 경우 이 개인정보 보호정책을 준수할 것을 요구하며, 자체 정책도 있습니다. 그러나 Remove Background는 해당 정책 준수에 대해 책임을 지지 않습니다.<br>
				일부 상황에서는 Remove Background가 수집된 개인 정보를 제3자와 공유, 사용 또는 보관할 수 있습니다:</p>
			<ul>
				<li>서비스 제공을 위해:</li>
			</ul>
			<p>당사를 대신하여 기능을 수행하는 서비스 제공업체로, 결제 서비스, 웹 호스팅, 비즈니스 분석, 고객 서비스 또는 웹 마케팅을 포함합니다. 이러한 서비스 제공업체는 기능 수행에 필요한 정보를 수집하고 접근할 수 있지만, 다른 목적으로 정보를 공유하거나 사용할 수 없습니다.</p>
			<ul>
				<li>적절한 권한 당국과 협력하기 위해:</li>
			</ul>
			<p>법적 요구 사항, 법적 절차 또는 정당한 이익을 충족하기 위해 필요한 경우. 어떤 경우든지, 필요한 정보만 제공됩니다.</p>


			<h3>8. 보안 조치</h3>
			<p>Remove Background는 수집된 개인 및 비개인 정보의 보안과 무결성을 보호하기 위해 필요한 모든 기술적 및 조직적 조치를 채택합니다. 
				무단 접근 및 우발적 변경, 손실 또는 파괴로부터 보호합니다.<br>
				어떤 경우에도, Remove Background는 수집된 정보의 절대적인 보안을 보장할 수 없으므로, 공유된 정보에 대해 항상 협력하고 상식을 사용해야 합니다.<br>
				사용자는 삭제 후에도 개인 및 비개인 정보가 캐시에 남아있을 수 있으며, 다른 사용자가 복사하거나 저장한 경우에도 여전히 보일 수 있음을 이해하고 인정합니다.</p>


			<h3>9. 개인정보 보호정책 변경</h3>
			<p>미래에 이 개인정보 보호정책을 업데이트할 수 있습니다. 제공된 이메일 주소로 통지하거나 웹사이트의 눈에 띄는 곳에 공지를 게시하여 변경 사항을 알려드리겠습니다.</p>


			<h3>10. 연락처</h3>
			<p>이 개인정보 보호정책에 대해 질문이 있는 경우 다음 주소로 연락하십시오:</p>
			<p>이메일: {supportLink}<br> 
				주소: Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spain.</p>
		`
	},
	gdpr: {
		lastUpdate: '마지막 업데이트: 2024년 6월 10일',
		content: `
			<h3>1. 책임자 및 연락 방법은 무엇인가요?</h3>
			<p>이 사이트의 책임자는 Remove Background S.L로, 주소는 Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spain입니다.</p>
			<p>이메일 {supportLink}을 통해 연락할 수 있습니다.</p>

			<h3>2. 어떤 데이터가 수집되나요?</h3>
			<p>
				쿠키를 통해 자동으로 데이터를 수집하며, 분석도 포함됩니다. 
				또한 연결된 IP 주소, 사용된 장치 유형 및 특성, 운영 체제 버전, 브라우저 유형, 언어, 날짜, 국가, 요청 시간, 
				참조 URL, 이동할 URL 또는 사용된 모바일 네트워크 등의 정보를 수집합니다.<br>
				사용자는 연락처 정보를 제공하고, 서비스에 가입하거나 구독을 구매하기 위해 이름과 성, 이메일 또는 은행 정보를 자발적으로 제공합니다.
			</p>

			<h3>3. 수집된 데이터는 무엇에 사용되나요?</h3>
			<p>
				서비스는 수집된 데이터를 관리하고 업데이트하며, 사용자의 요청에 응답하고, 
				이메일을 통해 뉴스레터와 프로모션 제안을 보내며, 플랫폼에 대한 사용자의 등록을 관리하고, 
				구독과 관련된 서비스를 관리 및 제공하고, 결제를 처리하고 해당 청구서를 발행하며, 
				서비스의 보안을 유지하고, 불법 활동을 조사하고, 약관을 시행하고, 
				국가 보안 기관의 조사에 협력하기 위해 사용합니다.
			</p>

			<h3>4. 얼마나 오랫동안 보관되나요?</h3>
			<ul>
				<li>집계된 데이터는 삭제 기간 없이 보관됩니다.</li>
				<li>
					고객 데이터는 최소한으로 보관되며, 다음 기간까지 보관될 수 있습니다:
					<ul>
						<li>5년, 민법 제1964조에 따라 (특별 기한 없는 개인 행동).</li>
						<li>6년, 상법 제30조에 따라 (회계 장부 또는 송장 등).</li>
					</ul>
				</li>
				<li>사용자 데이터는 요청을 처리하기 위해 최대 12개월 동안 보관됩니다.</li>
				<li>서비스가 소셜 네트워크 페이지 및 프로필에 업로드한 사용자 데이터는 사용자가 동의를 제공한 시점부터 철회할 때까지 보관됩니다.</li>
			</ul>

			<h3>5. 사용자로서의 권리는 무엇인가요?</h3>

			<p>
				접근 권한: 해당자는 데이터 관리자가 자신에 대한 개인 데이터를 처리하고 있는지 여부를 확인할 권리가 있습니다.
			</p>
			<p>
				수정 권한: 해당자는 데이터 관리자로부터 자신에 대한 부정확한 개인 데이터를 신속하게 수정받을 권리가 있습니다. 또한, 추가 선언을 통해 불완전한 개인 데이터를 완성할 권리가 있습니다.
			</p>
			<p>
				삭제 권한: 해당자는 데이터 관리자로부터 자신에 대한 개인 데이터를 신속하게 삭제받을 권리가 있습니다.
			</p>
			<p>
				데이터 처리 제한 권한: 해당자는 데이터 관리자가 자신의 데이터를 처리하는 것을 제한할 수 있으며, 이 권리의 행사는 두 가지 측면이 있습니다: 1) 자신의 개인 데이터의 정확성에 이의를 제기하는 경우, 데이터 관리자가 이를 확인할 수 있는 기간 동안 데이터 처리가 제한됩니다. 2) 데이터 관리자가 정당한 이익 또는 공익 임무를 기반으로 자신의 개인 데이터를 처리하는 경우, 데이터 관리자가 자신의 이유가 더 우선하는지 확인하는 동안 데이터 처리가 제한됩니다.
			</p>
			<p>
				데이터 이동 권한: 해당자는 자신에 대한 개인 데이터를 구조화된 형식으로 받아 다른 데이터 관리자에게 전송할 권리가 있습니다.
			</p>
			<p>
				이와 관련하여, 해당자는 개인 데이터를 한 데이터 관리자에서 다른 데이터 관리자에게 직접 전송할 수 있는 권리가 있습니다.
			</p>

			<h3>6. 권리를 어떻게 행사할 수 있나요?</h3>

			<p>
				개인 데이터 권리는 언제든지 이메일 {supportLink} 또는 우편 주소: 
				Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spain로 행사할 수 있습니다. 이 경우, 이름과 성명 및 필요한 경우 DNI 또는 국가 신분증 사본을 제공하여 본인임을 확인해야 합니다.<br>
				또한, Remove Background가 데이터 처리에 문제가 있다고 생각되면, <a href="{knowYourRightsLink}">해당 데이터 보호 기관</a>에 불만을 제기할 수 있으며, 스페인의 경우 <a href="{aepdLink}">스페인 데이터 보호 기관</a>에 불만을 제기할 수 있습니다.
			</p>

			<h3>7. 보안 조치가 취해지나요?</h3>
			<p>
				서비스는 수집된 개인 및 비개인 정보의 보안과 무결성을 보호하기 위해 필요한 모든 기술적 및 조직적 조치를 채택합니다. 무단 접근 및 우발적 변경, 손실 또는 파괴로부터 보호합니다.<br>
				어떤 경우에도, 서비스는 수집된 정보의 절대적인 보안을 보장할 수 없으므로, 공유된 정보에 대해 항상 협력하고 상식을 사용해야 합니다.<br>
				사용자는 삭제 후에도 개인 및 비개인 정보가 캐시에 남아있을 수 있으며, 다른 사용자가 복사하거나 저장한 경우에도 여전히 보일 수 있음을 이해하고 인정합니다.
			</p>

			<h3>8. 개인 데이터의 이전 또는 국제 이전이 있나요?</h3>

			<p>
				데이터 이전 또는 국제 이전은 없습니다. 그러나 서비스의 일부를 관리하는 제3자가 있으며, 이들은 Remove Background의 개인정보 보호정책을 준수해야 하며, 자체 정책도 있습니다. 이러한 제3자는 웹 호스팅, 분석 모니터링 또는 웹 개발과 같은 기능을 수행하는 서비스 제공업체입니다.<br>
				또한, 법적 요구 사항이나 정당한 이익을 충족하기 위해 필요한 경우 제3자에게 필요한 정보를 제공할 수 있습니다. 어떤 경우에도 필요한 정보만 제공됩니다.
			</p>

		`
	},
	cookiesPolicy: {
		lastUpdate: '마지막 업데이트: 2024년 6월 21일',
		content: `
			<h3>요약</h3>
			<ul>
			    <li>사용된 쿠키: <strong>자체 및 타사</strong></li>
			    <li>통계 수집에 사용되나요? <strong>예, 서비스 관리 개선을 위한 정당한 이익을 바탕으로 합니다.</strong></li>
			    <li>이 웹사이트를 통해 쿠키를 설치하는 타사 서비스: <strong>Google, Google Analytics, Cloudflare, Stripe</strong></li>
			</ul>

			<h3>쿠키 구성 및 비활성화 방법</h3>
			<p>
			    웹 브라우저에서 기기에 설치된 쿠키를 허용, 차단 또는 삭제할 수 있습니다. 기기에 쿠키 설치를 허용하지 않으면 
			    탐색 경험이 악화될 수 있습니다. 아래에서 각 브라우저에서 쿠키를 구성하는 방법을 찾을 수 있습니다:
			</p>
			<ul>
			    <li><a href="{externalLink: edgeCookies}">Edge</a></li>
			    <li><a href="{externalLink: chromeCookies}">Google Chrome</a></li>
			    <li><a href="{externalLink: googleAndroidCookies}">Google Android</a></li>
			    <li><a href="{externalLink: internetExplorer8Cookies}">Internet Explorer 8</a></li>
			    <li><a href="{externalLink: internetExplorer9Cookies}">Internet Explorer 9</a></li>
			    <li><a href="{externalLink: internetExplorer11Cookies}">Internet Explorer 11</a></li>
			    <li><a href="{externalLink: firefoxCookies}">Mozilla Firefox</a></li>
			    <li><a href="{externalLink: operaCookies}">Opera</a></li>
			    <li><a href="{externalLink: safariCookies}">Safari</a></li>
			    <li><a href="{externalLink: safariMobileCookies}">Safari Mobile</a></li>
			</ul>

			<h3>1. 종류 및 용도</h3>
			<p>서비스는 탐색을 개선하고 서비스를 제공하며 웹사이트 사용에 대한 통계를 얻기 위해 자체 및 타사 쿠키를 사용합니다.</p>

			<h3>2. 쿠키란 무엇이며 무엇에 사용되나요?</h3>
			<p>
			    쿠키는 컴퓨터, 모바일 또는 태블릿 웹 브라우저로 전송되는 텍스트 파일로, 
			    탐색에 대한 정보를 저장하고 검색하는 데 사용됩니다. 예를 들어, 사용자 이름과 비밀번호 또는 프로필 환경설정을 기억하기 위해 사용됩니다.
			</p>

			<h3>3. 쿠키의 종류는 무엇인가요?</h3>
			<p>관리 주체에 따라:</p>
			<ul>
			    <li>자체 쿠키; 당사의 장비 또는 웹 도메인에서 사용자의 브라우저로 전송됩니다.</li>
			    <li>타사 쿠키; 당사가 직접 관리하지 않는 장비 또는 웹 도메인에서 사용자의 브라우저로 전송됩니다. 예: Google.</li>
			</ul>
			<p>활성화 기간에 따라:</p>
			<ul>
			    <li>세션 쿠키; 사용자가 웹사이트를 떠날 때까지 브라우저의 쿠키 폴더에 남아 있으며, 기기에 남지 않습니다.</li>
			    <li>영구 쿠키; 기기에 남아 있으며, 사용자가 새로운 방문을 할 때마다 웹사이트가 이를 읽습니다. 이러한 쿠키는 특정 날짜 이후에 작동을 중지합니다.</li>
			</ul>
			<p>마지막으로, 목적에 따라:</p>
			<ul>
			    <li>기술적 쿠키; 탐색을 개선하고 웹사이트의 올바른 작동을 보장합니다.</li>
			    <li>개인화 쿠키; 일련의 기준에 따라 사전 정의된 특성으로 서비스에 접근할 수 있습니다.</li>
			    <li>분석 쿠키; 제공된 서비스의 사용을 측정하고 통계적으로 분석할 수 있습니다.</li>
			</ul>
			<p><strong>remove-background.com</strong>에서 사용하는 타사 쿠키 목록</p>
			<ul>
			    <li>
			        <a href="{externalLink: googleCookiesPolicy}">Google</a>: Google의 쿠키(NID 또는 CONSENT)는 Google 외부에서 광고가 표시되는 방식을 개인화하거나 
			        검색 결과 표시 시 선호하는 언어와 같은 정보를 저장할 수 있습니다.<br><a href="{externalLink: googleCookieTypes}">Google이 다양한 서비스에서 사용하는 쿠키 유형</a>에 대한 자세한 정보.
			    </li>
			    <li>
			        <a href="{externalLink: googleAnalyticsCookies}">Google Analytics</a>: Google Analytics의 쿠키(예: _ga)는 사용자가 웹사이트를 방문한 횟수, 방법, 시기 및 출처를 계산할 수 있습니다.<br>
			        어떤 경우든지, 여기에서 Google Analytics 쿠키를 비활성화할 수 있습니다: <a href="{externalLink: disableGoogleAnalytics}">here</a>.
			    </li>
			    <li>Cloudflare: Cloudflare의 쿠키 정책 및 사용에 대한 자세한 내용은 <a href="{externalLink: cloudflareCookiesPolicy}">여기</a>를 클릭하십시오.</li>
			    <li>Stripe: Stripe의 쿠키 정책 및 사용에 대한 자세한 내용은 <a href="{externalLink: stripeCookiesPolicy}">여기</a>를 참조하십시오.</li>
			</ul>
			
		`
	}
};
